import React, { useState } from "react";
import Style from "./EachComment.module.css";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Input from "../Input/Input";
import Button from "../Button/Button";
import { errorToast, succToast } from "../../Utils/Toast/Toast";
import { ReplyCommentAPI } from "../../Api/SupplierServices";
import { splitJalaliDateTime } from "../../Functions/convertDateToJalali";

const EachComment = ({ item, updateList, getOrderListHandler }) => {
  const [CommentText, setCommentText] = useState("");

  const setReplyTextHandler = (id) => {
    if (CommentText === "") {
      errorToast("لطفا پاسخ خودرا واردکنید!");
    } else {
      let info = {
        id: id,
        message: CommentText,
      };
      ReplyCommentAPI(info, (succ) => {
        if (succ.status === 1) {
          succToast(succ.message);
          updateList();
        } else {
          errorToast(succ.message);
        }
      });
    }
  };
  return (
    <li className={Style.EachComments}>
      <ul className={Style.CommentInfoHolder}>
        <li className={Style.CommentInfo}>
          <p>
            {" "}
            <FontAwesomeIcon icon={faUser} /> رمضون علی غزل باش اصل{" "}
          </p>
          <div>
            <p>{splitJalaliDateTime(item.ucs_date).date}</p>{" "}
            <span>{splitJalaliDateTime(item.ucs_date).time}</span>
          </div>
        </li>
        <li className={Style.CommentInfo}>
          <p className={Style.situation}>
            {item.status === "0" ? "درحال برسی" : "تایید شده"}
          </p>
          <span className={Style.score}>{item.score}</span>
        </li>
        <li className={Style.CommentInfo}>
          <p className={Style.CommentText}>{item.ucs_message}</p>
        </li>
        {item.ucsr_message === null ? (
          <li className={Style.ResponseInput}>
            <Input
              inputtype="textArea"
              type={"textarea"}
              placeholder={"پاسخ خودرا بنویسد..."}
              value={CommentText}
              onChange={(e) => setCommentText(e.target.value)}
            />
            <div className={Style.BtnHolder}>
              <Button
                Value={"ثبت"}
                ClassBtn={"confirmBtn"}
                ClickHandler={() => setReplyTextHandler(item.id)}
              />
              <Button
                Value={"سفارش"}
                ClassBtn={"borderRed"}
                ClickHandler={() => getOrderListHandler(item.order_id)}
              />
            </div>
          </li>
        ) : (
          <li className={Style.ResponseHolder}>
            <p className={Style.ResponseText}>{item.ucsr_message}</p>
            <div className={Style.BtnHolder}>
              <Button
                Value={"سفارش"}
                ClassBtn={"borderRed"}
                ClickHandler={() => getOrderListHandler(item.order_id)}
              />
            </div>
          </li>
        )}
      </ul>
    </li>
  );
};

export default EachComment;
